import { transformDataTestIds } from '@backoffice-frontend/common'
import { HubsAreaId } from './HubsAreaId'

export const HubsAreaDataTestIds = transformDataTestIds({
  Base: HubsAreaId,
  Details: {
    Base: 'details',
    HubDataForm: 'hub-form',
  },
})
